import { Typography } from "@mui/material";
import Container from "@mui/material/Container";

function FinalInfo() {
  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            IMPORTANT INFO FOR THOSE ATTENDING MANCHESTER PSYCH FEST 2026
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Wristband Collection x Cactus Square
          </Typography>

          <Typography className="text">
            Please collect your wristband from{" "}
            <a
              href="/2026/wristband-collection"
              rel="noopener noreferrer"
            >
              #2 Circle Square
            </a>
            , Brancaster Rd side entrance, from 10am-9pm. This is next door to
            #1 where previous wristband collections have been.
          </Typography>

          <Typography className="text">
            The first live band is on at 1.30pm so we advise arriving as early
            as possible to help avoid disappointment. You cannot collect
            wristbands for other people.
          </Typography>

          <Typography className="text">
            Tickets will be scanned so e-tickets or pdf downloads on your smart
            phone will suffice.
          </Typography>

          <Typography className="text">
            You do not need your wristband to enter Circle Square. But you will
            need it to enter any live music venue.
          </Typography>

          <Typography className="text">
            Circle Square = Art Installations & Exhibitions / Festival Merch
            Shop / Festival Bar / Food / DJs / Hang out / Yoga / Postcards &
            Tie-dye workshops
          </Typography>

          <Typography className="text">
            Socks tie-dye workshop - this is limited to 25 people per hour. You
            will need to purchase festival merch to be eligible to take part
            (including online sales).
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            FREE TOTES - first come, first serve
          </Typography>

          <Typography className="text">
            We’re giving 2000 tote bags to the first through the doors.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Bag & Camera Policy – Security
          </Typography>

          <Typography className="text">
            Large bags – including rucksacks are not allowed.
          </Typography>

          <Typography className="text">
            There are no facilities to leave large bags or luggage.
          </Typography>

          <Typography className="text">
            If you really have to bring a bag – and it’s preferable you don’t –
            please make sure it’s small.
          </Typography>

          <Typography className="text">
            Only one small bag per person is permitted and it must not be bigger
            than A4 size.
          </Typography>

          <Typography className="text">Height: 28.7cm</Typography>
          <Typography className="text">Width: 21cm</Typography>
          <Typography className="text">Depth 15cm</Typography>

          <Typography className="text">
            Cameras without photo accreditation are also not allowed.
          </Typography>

          <Typography className="text">
            Manchester Psych Fest tote bags and Beta Band bags (from merch
            stall) will be allowed.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Projekts Skate Park
          </Typography>

          <Typography className="text">
            We have closed Baring St to help enhance the experience at the Skate
            Park.
          </Typography>

          <Typography className="text">
            Entrance/exit will now be on Baring St where we have also moved all
            the toilets.
          </Typography>

          <Typography className="text">No glass.</Typography>
          <Typography className="text">No chewing gum.</Typography>
          <Typography className="text">No skating.</Typography>

          <Typography className="text">
            Please do not bring a skate board/skates/bmx/roller blades etc as
            you may be refused entry.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            NHS
          </Typography>

          <Typography className="text">
            If you have purchased a ticket with NHS discount, you will need your
            NHS I.D when collecting your wristband. 1 per person.
          </Typography>

          <Typography className="text">
            Failure to do so will result in a £15 charge at the collection
            point.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            U24s Ticket
          </Typography>

          <Typography className="text">
            If you have purchased an under 24s ticket, you will need to show
            valid photo.
          </Typography>

          <Typography className="text">
            I.D = passport, driving license or national I.D card.
          </Typography>

          <Typography className="text">
            Failure to do so will result in a £15 charge.
          </Typography>

          <Typography className="text">
            DOB must be on or after 5/9/2021.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Access
          </Typography>

          <Typography className="text">
            We advise you to contact venues in advance but each space will have
            limited seats/access area.
          </Typography>

          <Typography className="text">
            Info:{" "}
            <a
              href="/2026/accessibility"
              rel="noopener noreferrer"
            >
              Accessibility Information
            </a>
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Stage Times
          </Typography>

          <Typography className="text">
            All stage times can be found via our free app.
          </Typography>

          <Typography className="text">
            Link to app:{" "}
            <a
              href="https://woov.to/manchesterpsychfest26"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Here
            </a>
          </Typography>

          <Typography className="text">
            Please note, venues are strictly first come, first serve so please
            arrive as early as you can to see anyone specific. Some venues will
            stop people entering towards the end of a set to allow for crowds to
            leave before the next act.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Angine De Poitrine - Apollo
          </Typography>

          <Typography className="text">
            We are anticipating Angine’s set to be very popular.
          </Typography>

          <Typography className="text">
            There are standing or seated options in the Apollo. Both areas are
            first come, first serve.
          </Typography>

          <Typography className="text">
            If you chose to seat, please take up all the seats and leave no gaps
            - this will help get to the maximum capacity in the venue.
          </Typography>

          <Typography className="text">
            Arriving early will give you a better chance to get in.
          </Typography>

          <Typography className="text">
            Whilst we cannot guarantee everyone will get in, we have tried our
            utmost to programme a lot of other choices &gt;{" "}
            <a
              href="https://www.yuckmagazine.co.uk/features/angine-de-poitrine-manchester-psych-fest-clash-finder-set-times"
              target="_blank"
              rel="noopener noreferrer"
            >
              We have 12 other acts that cross over with their set time.
            </a>
          </Typography>

          <Typography className="text">
            Please bare in mind, it will take a short while for people to enter
            the Apollo. There also might be a delay whilst people leave from a
            previous set.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Ages
          </Typography>

          <Typography className="text">
            14+ (under 18s accompanied by adult) (before 11pm)
          </Typography>

          <Typography className="text">
            Apollo, Academy 1, o2 Ritz, Projekts Skate Park, Gorilla, Deaf
            Institute, The Abbey.
          </Typography>

          <Typography className="text">18+ (after 11pm)</Typography>

          <Typography className="text">
            YES, The Bread Shed, Lass O'Gowrie + all venues.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Merch x Hikerdelic
          </Typography>

          <Typography className="text">
            There will be an official festival merch shop on Circle Square:
          </Typography>

          <Typography className="text">
            Friday: 3pm-7pm + Saturday 10am-7pm.
          </Typography>

          <Typography className="text">
            <a
              href="https://hikerdelic.com/collections/hikerdelic-x-psychfest"
              target="_blank"
              rel="noopener noreferrer"
            >
              Merch can also be purchased online here.
            </a>
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Food
          </Typography>

          <Typography className="text">
            <a
              href="/2026/food"
              rel="noopener noreferrer"
            >
              Full info on food outlets here.
            </a>
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Drinks/Bars
          </Typography>

          <Typography className="text">
            All prices at the bars are pre-determined by the venues and not the
            festival.
          </Typography>

          <Typography className="text">
            We have a festival bar with drinks from £4.50 based outside
            wristband Collection at Festival Square.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Go Green
          </Typography>

          <Typography className="text">
            No Official Festival Parking. We strongly encourage people to arrive
            by foot, bike or public transport.
          </Typography>

          <Typography className="text">
            Wear comfortable shoes. Buses run regularly up and down Oxford Rd
            which can help you get around some of the venues.
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Public Transport - Wristband Collection (Circle Square, Oxford Road)
          </Typography>

          <Typography className="text">
            Beryl Bikes: Circle Square/Oxford Rd (0.0 miles)
          </Typography>

          <Typography className="text">
            Bikes: Oxford Road Cycle Hub (0.1 miles)
          </Typography>

          <Typography className="text">
            Bus Stop: Oxford Rd Station (0.1 miles)
          </Typography>

          <Typography className="text">
            Metro: St Peters Square (0.4 miles)
          </Typography>

          <Typography className="text">
            Train Oxford Rd Station (0.1 miles)
          </Typography>

          <Typography className="text">
            Train Piccadilly Station (0.7 miles)
          </Typography>

          <Typography className="text">
            Train Victoria Station (1.0 miles)
          </Typography>

          <Typography className="text">
            Coach Shudehill Bus Station (0.9 miles)
          </Typography>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Have a top day!
          </Typography>

          <Typography className="text">Manchester Psych Fest x</Typography>
        </div>
      </div>
    </Container>
  );
}
export default FinalInfo;
